<template>
	<div  id="generic" role="tabpanel">
        <div class="row">
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-1.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                           <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-2.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Carbamide Forte Alfalfa + Calcium Citrate Malate 1200mg + Vitamin D + K2 (MK 7) Vegetarian Tablet</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <div class="button mt-4">
                            <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-3.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                            <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-1.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                            <a href="#" class="btn btn-gray-dark click-here">Re-order</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-1.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                           <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-2.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Carbamide Forte Alfalfa + Calcium Citrate Malate 1200mg + Vitamin D + K2 (MK 7) Vegetarian Tablet</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <div class="button mt-4">
                            <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-3.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                            <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 mb-4 card border-0">
                <div class="card-body border-0 bg-body border-radius-5 p-0 shop-product">
                    <figure class="mb-0 p-3">
                        <router-link to="/suppliment-product"><img src="../../../../../static/website/images/Gini-product-1.png" alt="" /></router-link>
                    </figure>
                    <div class="text-center px-3 pb-3">
                        <h2>Gini Multivitamins</h2>
                        <h3>US$ 179.95</h3>
                        <ul class="d-flex my-3 justify-content-center rating">
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                            <li>
                                <a href="#"><i class="icon icon-star"></i></a>
                            </li>
                        </ul>
                        <p>Decode your gene-health- nutrition relationship</p>
                        <div class="button mt-4">
                            <router-link to="/cart-suppliment" class="btn btn-blue click-here">Buy Now</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Nutrition",
        data() {
            return {

            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/website/nutrition/pages/generic-suppliment.vue